<template>
  <div class="control has-icons-right"
    :class="{ 'has-icons-left' : showLeftIcon }">
    <input class="input"
      v-model="innerValue"
      v-bind="$attrs"
      :type="inputType">
    <span v-show="showLeftIcon"
      class="icon is-left">
      <i :class="leftIconClass" />
    </span>
    <span class="icon is-right is-clickable"
      :class="`has-text-${iconColour}`"
      @click="togglePasswordReveal()">
      <i class="mdi mdi-24px"
        :class="iconType" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'BulmaPasswordInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    iconColour: {
      type: String,
      default: 'primary'
    },
    showLeftIcon: {
      type: Boolean,
      default: true
    },
    defaultLeftIcon: {
      type: String,
      default: 'mdi-shield-account'
    },
    defaultLeftIconSize: {
      type: Number,
      default: 18
    }
  },
  data() {
    return {
      innerValue: this.value,
      inputType: 'password',
      revealPassword: false,
      iconType: 'mdi-eye-off'
    }
  },
  computed: {
    leftIconClass() {
      let iconClass = ''
      if (this.showLeftIcon) {
        iconClass = `mdi ${this.defaultLeftIcon} mdi-${this.defaultLeftIconSize}px`
      }
      return iconClass
    }
  },
  watch: {
    innerValue: function(newVal, oldVal) {
      this.$emit('input', newVal)
    }
  },
  created() {
    this.innerValue = this.value
  },
  mounted() {},
  methods: {
    togglePasswordReveal() {
      this.revealPassword = !this.revealPassword
      if (this.revealPassword) {
        this.inputType = 'text'
        this.iconType = 'mdi-eye'
      } else {
        this.inputType = 'password'
        this.iconType = 'mdi-eye-off'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  &.is-clickable {
    pointer-events: auto !important;
    cursor: pointer;
  }
}
</style>
